import React, {useEffect} from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom"
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AllFilters from "./pages/AllFilters";
import OilFilters from "./pages/OilFilters";
import OilFilter from "./pages/OilFilter";
import AirFilters from "./pages/AirFilters";
import AirFilter from "./pages/AirFilter";
import CabinFilters from "./pages/CabinFilters";
import CabinFilter from "./pages/CabinFilter";
import FuelFilters from "./pages/FuelFilters";
import FuelFilter from "./pages/FuelFilter";
import NotFound from "./pages/NotFound";
import Cart from "./pages/Cart";
import OilList from "./pages/OilList";
import Oil from "./pages/Oil";
import Brakes from "./pages/Brakes";
import Additive from "./pages/Additive";
import AdditiveList from "./pages/AdditiveList";
import Maslo from "./pages/WrongFolder/Maslo";
import ThankYou from "./pages/ThankYou";
import WrongPage from "./pages/WrongFolder/WrongPage";
import PrivateRoute from "./components/PrivateRoute";
import Customers from "./pages/WrongFolder/Customers";
import Products from "./pages/WrongFolder/Products";
import CarFilterConnections from "./pages/WrongFolder/CarFilterConnections";
import CarFilterConnectionTest1 from "./pages/WrongFolder/CarFilterConnectionTest1";
import Orders from "./pages/WrongFolder/Orders";
import Order from "./pages/WrongFolder/Order";
import Coupons from "./pages/WrongFolder/Coupons";
import Popups from "./pages/WrongFolder/Popups";
import './App.css';
import { ProductProvider } from "./context/products/ProductContext";
import { ToastContainer } from 'react-toastify';
import SearchProducts from "./pages/SearchProducts";
import SearchProduct from "./components/layout/SearchProduct";
import Invoice from "./pages/WrongFolder/Invoice";
import ResetPassword from "./pages/WrongFolder/ResetPassword";
import NavbarBanner from "./components/layout/NavbarBanner";
import CookieConsentBanner from "./components/layout/CookieConsentBanner";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import VisionAndMision from './pages/VisionAndMision';
import DeliveryPolicy from './pages/DeliveryPolicy';
import TermsOfUse from './pages/TermsOfUse';
import BlogList from './pages/BlogList';
import Blog from './pages/Blog';
import BlogsManagement from './pages/WrongFolder/BlogsManagement';
import Popup from '../src/components/layout/Popup'
import ReactGA from "react-ga4";
import { initFacebookPixel, trackPageView } from './utils/pixel.jsx';



function App() {
  const location = useLocation();

  useEffect(() => {
    
    const consent = localStorage.getItem('cookieConsent');
    const analyticsConsent = localStorage.getItem('analyticsConsent');

    if (consent === 'true' && analyticsConsent === "true") {
      ReactGA.initialize('G-3ZD3VLX0CN');
      ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
      initFacebookPixel();
    }
  }, []);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    const analyticsConsent = localStorage.getItem('analyticsConsent');

    if (consent === 'true' && analyticsConsent === "true") {
      trackPageView();
    }
  }, [location.pathname]);

  return (
    <ProductProvider>
      <CookieConsentBanner />
      <ToastContainer />
      <div className="flex flex-col h-screen">
        <NavbarBanner />
        <Navbar />
        <SearchProduct />
        <Popup />
        <main className="container mx-auto px-3 pb-12 flex-grow">
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/visionandmission' element={<VisionAndMision />} />
            <Route path='/allfilters' element={<AllFilters />} />
            <Route path='/oilfilters' element={<OilFilters />} />
            <Route path='/oilfilter/:id' element={<OilFilter />} />
            <Route path='/airfilters' element={<AirFilters />} />
            <Route path='/airfilter/:id' element={<AirFilter />} />
            <Route path='/cabinfilters' element={<CabinFilters />} />
            <Route path='/cabinfilter/:id' element={<CabinFilter />} />
            <Route path='/fuelfilters' element={<FuelFilters />} />
            <Route path='/fuelfilter/:id' element={<FuelFilter />} />
            <Route path='/oil/:id' element={<Oil />} />
            <Route path='/additives' element={<AdditiveList />} />
            <Route path='/additive/:id' element={<Additive />} />
            <Route path='/oils' element={<OilList />} />
            <Route path='/kocnici' element={<Brakes />} />
            <Route path='/cart' element={<Cart />} />
            <Route path='/searchProducts' element={<SearchProducts />} />
            <Route path='/thankYou' element={<ThankYou />} />
            <Route path='/maslo' element={<Maslo />} />
            <Route path='/notfound' element={<NotFound />} />
            <Route path='/*' element={<NotFound />} />
            <Route path='/privacyPolicy' element={<PrivacyPolicy />} />
            <Route path='/deliveryPolicy' element={<DeliveryPolicy />} />
            <Route path='/termsOfUse' element={<TermsOfUse />} />
            <Route path='/blogList' element={<BlogList />} />
            <Route path='/blog/:id' element={<Blog />} />
            <Route path='/invoice' element={<Invoice />} />
            <Route path='/resetPassword' element={<ResetPassword />} />

            <Route
              path="/wrongPage"
              element={
                <PrivateRoute element={<WrongPage />} />
              }
            >
              <Route path="customers" element={<Customers />} />
              <Route path="carFilterConnections" element={<CarFilterConnections />} />
              <Route path="orders" element={<Orders />} />
              <Route path="products" element={<Products />} />
              <Route path="coupons" element={<Coupons />} />
              <Route path="blogsManagement" element={<BlogsManagement />} />
              <Route path="popups" element={<Popups />} />
            </Route>
            <Route path="wrongPage/order/:id" element={<PrivateRoute element={<Order />} />} />
            <Route path="wrongPage/carFilterConnectionTest1/:id" element={<PrivateRoute element={<CarFilterConnectionTest1 />} />} />
          </Routes>
        </main>

        <Footer className="mt-auto" />
      </div>
    </ProductProvider>
  );
}

export default App;
